<template>
<v-select
    :items="items"
    v-model="value"
    label="Map value"
    dense
    outlined
></v-select>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    items: [
        {
            header: "Climate Risk",
            text: "Climate Risk",
            disabled: true
        },
        {
            text: 'ICE Climate Risk Score',
            value: 'risq_score'
        },
        {
            text: 'Hurricane Score',
            value: 'hurricane_score'
        },
        {
            text: 'Flood Score',
            value: 'flood_score'
        },
        {
            text: 'Wildfire Score',
            value: 'wildfire_score'
        },
        {
            text: "Social Impact",
            header: "Social Impact",
            disabled: true
        },
        {
            text: 'Social Impact Score',
            value: 'social_impact_score'
        },
        {
            text: 'Low Affluence Score',
            value: 'low_affluence_score'
        },
        {
            text: 'Low Educational Attainment Score',
            value: 'low_education_score'
        },
        {
            text: 'Low Prestige Employment Score',
            value: 'low_prestige_employment_score'
        },
        {
            text: 'Persistent Health Obstacles Score',
            value: 'health_obstacle_score'
        },
        {
            text: 'Poverty Concentration Score',
            value: 'poverty_concentration_score'
        },
        {
            text: 'Percent of Income Spent on Housing Score',
            value: 'pct_income_on_housing_score'
        },
        {
            text: 'Nonwhite/Minority Population Score',
            value: 'minority_score'
        }
    ]
  }),
  computed: {
      value: {
          get() {
              return `${this.$store.state.mapMetric}_score`
          },
          set(val) {
            this.$store.dispatch('setMapMetric', val.replace(/_score$/,''))
          }
      },

    ...mapState({
      loading: 'loading',
      user: 'user',
    }),
  },
  methods: {
  },
  watch: {

  }

}
</script>
<style scoped>
</style>
